import { render } from "./descriptionComponent.vue?vue&type=template&id=babba036"
import script from "./descriptionComponent.vue?vue&type=script&lang=js"
export * from "./descriptionComponent.vue?vue&type=script&lang=js"

import "./descriptionComponent.vue?vue&type=style&index=0&id=babba036&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__